module.exports = __webpack_public_path__ + "img/landing-info-two.fe1d7657.png";